export const PROFILE_MAX_WIDTH = 1200;
export const PROFILE_MIN_WIDTH = 800;
export const PROFILE_PADDING = 32;
